var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1858 1H2.82106C1.37175 1 0.507299 2.59629 1.31123 3.78803L6.07931 10.0229C6.47675 10.612 6.68883 11.3043 6.68883 12.0123V16.7682C6.68883 17.567 7.66611 17.9671 8.23768 17.4022L10.0523 15.609C10.2224 15.4408 10.318 15.2127 10.318 14.9749V12.0123C10.318 11.3043 10.5301 10.612 10.9275 10.0229L15.6956 3.78803C16.4995 2.59629 15.6351 1 14.1858 1Z",
    stroke: "#011224",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.f03b71b10475f5f269afc2d7b06d2ac5.svg";
export { ForwardRef as ReactComponent };